<template>
  <div class="benefits-page page" style="width: 100%; background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;">
    <!-- 顶部导航 -->
    <van-nav-bar class="nav-bar" :title="$t('foorter.video')">
      <template #left>
        <van-icon name="arrow-left" size="22" color="#000" @click="onClickLeft()"/>
      </template>
    </van-nav-bar>

    <!-- 主内容 -->
    <div style="padding: 20px 20px 60px; background-color: unset;">
      
      <!-- 分类1：sex toys -->
      <div class="category-section">
        <div class="category-header">{{$t("auth.top8")}}</div>
        
        

        <div class="benefits-grid">
          <div class="benefit-card" v-for="(item, index) in sexToysList" :key="index" @click="toLottery('game1',10)">
            <div class="card-img-box">
              <img :src="item.img_url" class="card-img" />
            </div>
            <div class="card-title">{{$t("foorter.video")}} {{ index + 1 }}</div>
            <div class="card-btn">{{$t("auth.top10")}}</div>
          </div>
        </div>
<div class="info-banner">
<div class="banner-title">{{$t("auth.top11")}}</div>
<div class="banner-subtitle">{{$t("auth.top12")}}</div>
</div>
      </div>

      <!-- 分类2：Luxury goods -->
      <div class="category-section" style="margin-top: 40px;">
        <div class="category-header">{{$t("auth.top9")}}</div>
        
      

        <div class="benefits-grid">
          <div class="benefit-card" v-for="(item, index) in luxuryList" :key="index" @click="toLottery('5',11)">
            <div class="card-img-box">
              <img :src="item.img_url" class="card-img" />
            </div>
            <div class="card-title">{{$t("foorter.video")}} {{ index + 1 }}</div>
            <div class="card-btn">{{$t("auth.top10")}}</div>
          </div>
        </div>
      </div>
<div class="info-banner">
<div class="banner-title">{{$t("auth.top13")}}</div>
<div class="banner-subtitle">{{$t("auth.top14")}}</div>
</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sexToysList: [], // sex toys 分类数据
      luxuryList: [], // Luxury goods 分类数据
      loading: false,
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    
    toLottery(key,id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/Lottery?key='+key+"&id="+id})
      }
    },

    // 获取 sex toys 分类数据（请求参数不同）
    getSexToysList() {
      this.$http({
        method: "get",
        url: "xuanfeilist2",
        data: { 
          // 这里填你的分类参数，例如：category: 'sex_toys' 
          home_class: '3',
        },
      }).then((res) => {
        if (res.code === 200) {
          this.sexToysList = res.data || [];
          this.handleLangData(this.sexToysList);
        }
      });
    },

    // 获取 Luxury goods 分类数据（请求参数不同）
    getLuxuryList() {
      this.$http({
        method: "get",
        url: "xuanfeilist2",
        data: { 
          // 这里填你的分类参数，例如：category: 'luxury_goods' 
          home_class: '4',
        },
      }).then((res) => {
        if (res.code === 200) {
          this.luxuryList = res.data || [];
          this.handleLangData(this.luxuryList);
        }
      });
    },

    // 处理多语言数据（如果你需要）
    handleLangData(list) {
      const lanng = localStorage.getItem("lang") || "ja";
      list.forEach(item => {
        if (item.flag) {
          const parts = item.flag.split('|');
          if (lanng == 'zh') item.flag = parts[0];
          else if (lanng == 'en') item.flag = parts[1];
          else if (lanng == 'ja') item.flag = parts[2];
          else item.flag = parts[3];
        }
      });
    },
  },
  created() {
    this.getSexToysList();
    this.getLuxuryList();
  },
};
</script>

<style lang="less" scoped>
.benefits-page {
  position: absolute !important;
  min-height: 100vh;
}

.nav-bar {
  background: unset;
  height: 100px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #000;
  font-size: 35px;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

/* 分类标题 */
.category-header {
  background: #c858c8;
  color: #fff;
  font-size: 28px;
  font-weight: bold;
  padding: 10px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}

/* 信息横幅 */
.info-banner {
  background: #f85a8e;
  color: #fff;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  text-align: center;
}

.banner-title {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 8px;
}

.banner-subtitle {
  font-size: 20px;
  opacity: 0.9;
}

/* 奖品网格 - 一行两个 */
.benefits-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
}

.benefit-card {
  width: calc(50% - 8px);
  background: #fff;
  border-radius: 12px;
  padding: 12px 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.card-img-box {
  width: 100%;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
  background: #f5f5f5;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-title {
  font-size: 22px;
  color: #000;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: center;
}

.card-btn {
  width: 100%;
  background: linear-gradient(90deg, #d05ad4, #a43bd4);
  color: #fff;
  font-size: 22px;
  font-weight: 500;
  padding: 10px 0;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
}

/* 响应式调整 */
@media screen and (max-width: 375px) {
  .card-img-box {
    height: 150px;
  }
  .banner-title {
    font-size: 22px;
  }
  .banner-subtitle {
    font-size: 16px;
  }
  .card-btn {
    font-size: 18px;
    padding: 8px 0;
  }
}
</style>